/**
 * The places the Copilot panel sends the clinic to, and the guidance that names
 * them (COPILOT-COPY-01). A sentence names a screen only through this list;
 * `panel-copy.test.tsx` checks every entry against the team workspace
 * navigation and the settings sections, so a renamed or removed screen fails a
 * test instead of leaving the clinic looking for it.
 */
export type PanelDestination = {
  /** The label the clinic reads on the navigation item. */
  label: string;
  /** Where that navigation item lives. */
  area: string;
  /** The route the item opens. */
  path: string;
};

export const AI_SETTINGS_DESTINATION: PanelDestination = {
  label: "Configurações da IA",
  area: "Espaço da equipe",
  path: "/growth-team",
};

export const PANEL_DESTINATIONS: readonly PanelDestination[] = [AI_SETTINGS_DESTINATION];

export const PANEL_COPY = {
  /** A finished run with nothing to show. "Tentar novamente" re-sends the turn. */
  noAnswer: `O assistente não respondeu. Tente de novo ou peça ao administrador da clínica para conferir ${AI_SETTINGS_DESTINATION.label}, no ${AI_SETTINGS_DESTINATION.area}.`,
  /** The service is not set up for this clinic: only CliniSharp can fix it. */
  notConfigured: "Fale com o suporte da CliniSharp.",
  missingUserToken: "Recarregue a página e entre novamente.",
} as const;
